export default __webpack_public_path__ + "static/media/smitesh.b74f72f1.png";